export default "__VITE_ASSET__27352f87__"